export default "__VITE_ASSET__B_1RZs2e__"